/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const MESSAGE_TYPE_PONG = 'pong';
export const MESSAGE_TYPE_CONFIRM_SUBSCRIBE = 'confirm-subscribe';
export const MESSAGE_TYPE_CONFIRM_UNSUBSCRIBE = 'confirm-unsubscribe';

export const WIRE_ACTION_PING = 'ping';
export const WIRE_ACTION_SUBSCRIBE = 'subscribe';
export const WIRE_ACTION_UNSUBSCRIBE = 'unsubscribe';

export const PROTOCOL_MESSAGE_TYPES = new Set([
  MESSAGE_TYPE_PONG,
  MESSAGE_TYPE_CONFIRM_SUBSCRIBE,
  MESSAGE_TYPE_CONFIRM_UNSUBSCRIBE,
]);

export const ERROR_TYPE_CONNECTION = 'connection';
export const ERROR_TYPE_SUBSCRIBE = 'subscribe';
export const ERROR_TYPE_UNSUBSCRIBE = 'unsubscribe';
export const ERROR_TYPE_MESSAGE = 'message';

export const CALLBACK_ON_MESSAGE = 'handler';
export const CALLBACK_ON_ERROR = 'onError';
export const CALLBACK_ON_SUBSCRIBED = 'onSubscribed';
export const CALLBACK_ON_UNSUBSCRIBED = 'onUnsubscribed';
export const CALLBACK_ON_CONNECT = 'onConnect';
export const CALLBACK_ON_DISCONNECT = 'onDisconnect';
